import type { ReactNode } from "react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../Select";

export interface IMultiSelectFilter {
  type: "multiSelect";
  values: string[];
}

export interface IFilterOption {
  value: string;
  label: ReactNode;
}

interface IMultiSelectFilterInputProps {
  value: IMultiSelectFilter | undefined;
  onChange: (value: IMultiSelectFilter | undefined) => void;
  options: IFilterOption[];
  placeholder?: string;
}

export function MultiSelectFilterInput({
  value,
  onChange,
  options,
  placeholder = "Select options…",
}: IMultiSelectFilterInputProps) {
  const handleChange = (selected: string[]) => {
    if (selected.length === 0) {
      onChange(undefined);
    } else {
      onChange({ type: "multiSelect", values: selected });
    }
  };

  return (
    <Select
      multiple
      searchable
      value={value?.values}
      onValueChange={(next: string[]) => handleChange(next)}
    >
      <SelectTrigger>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-w-[400px] w-auto">
        {options.map((o) => (
          <SelectItem key={o.value} value={o.value}>
            {o.label}
          </SelectItem>
        ))}
        {/* more items */}
      </SelectContent>
    </Select>
  );
}
